import { compare, getContrastTextColor } from "@l2r-front/l2r-utils"

export const getLegendItemForGrade = (legend, grade, theme) => {
    const legendItem = legend.find((item, index) => {
        const isFirst = index === 0
        const inRangeForFirst =
            isFirst &&
            compare(item.minValue, grade, item.minOperand ?? "<=") &&
            compare(item.maxValue, grade, item.maxOperand ?? ">=")

        const inRange =
            compare(item.minValue, grade, item.minOperand ?? "<") &&
            compare(item.maxValue, grade, item.maxOperand ?? ">=")
        return inRangeForFirst || inRange
    })

    if (legendItem) {
        return {
            ...legendItem,
            textColor: getContrastTextColor(theme.palette[legendItem.color].main),
        }
    }
    return null
}